import { html, render, TemplateResult } from "lit";
import { isBuffer } from "lodash";
import { JobItem } from "../data/search-data";
import { getModalLauncher } from "./modal-wrapper";

export class JobItemEdit {
    private viewContainer: HTMLElement | null;
    //the container we render into
    ui: HTMLDivElement;
    private data: JobItem;
    onSave: () => void;

    constructor(data: JobItem, onSave: () => void) {
        this.data = data;
        this.onSave = onSave;
        this.ui = this.newDiv();
        this.viewContainer = null;

    }
    private newDiv(): HTMLDivElement {
        const result = document.createElement('div');
        result.className += " jobitem-editor";
        return result;
    }

    private render() {
        render(this.template(), this.ui);
    }
    protected footerTemplate(): TemplateResult {
        const okButton =
            html`<button type="button" class="btn btn-primary" @click=${()=> this.ok()}>Ok</button>`;

        const cancelButton =
            html`<button type="button" class="btn btn-primary" @click=${()=> this.cancel()}>Cancel</button>`;

        return html`${okButton}${cancelButton}`;

    }
    cancel() {
        this.hideModal();
    }

    private template(): TemplateResult {
        return html`
            <div class="modal" tabindex="-1">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Edit Job Item</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div class="mb-3">
                                <label for="jobedit-windowId" class="form-label">Window ID</label>
                                <input type="text" class="form-control" id="jobedit-windowId" readonly
                                    .value=${this.data.displayRow.windowId} />
                            </div>
                            <div class="mb-3">
                                <label for="jobedit-width" class="form-label">Enter Width</label>
                                <input type="number" class="form-control" id="jobedit-width" .value=${this.data.width} />
                            </div>
                            <div class="mb-3">
                                <label for="jobedit-height" class="form-label">Enter Height</label>
                                <input type="number" class="form-control" id="jobedit-height" .value=${this.data.height} />
                            </div>
                            <div class="mb-3">
                                <label for="jobedit-calculation" class="form-label">@ Calculation</label>
                                <input type="number" class="form-control" readonly id="jobedit-calculation"
                                    .value=${this.data.calculation} />
                            </div>
                        </div>
                        <div class="modal-footer">
                            ${this.footerTemplate()}
                        </div>
                    </div>
                </div>
            </div>`;
    }


    protected ok() {
        let width: number | null = parseFloat((this.ui.querySelector('#jobedit-width') as HTMLInputElement).value);
        if (width === NaN) width = null;
        this.data.width = width;

        let height: number | null = parseFloat((this.ui.querySelector('#jobedit-height') as HTMLInputElement).value);
        if (height === NaN) height = null;
        this.data.height = height;

        let calculation: number | null = parseFloat((this.ui.querySelector('#jobedit-calculation') as HTMLInputElement).value);
        if (calculation === NaN) calculation = null;
        this.data.calculation = calculation;

        this.hideModal();
        if (this.onSave) this.onSave();

    }
    public showModal() {
        if (!this.container) this.container = document.body;
        const modalDialog = this.ui.firstElementChild as HTMLElement;
        getModalLauncher().show(modalDialog);
        modalDialog.addEventListener("hidden.bs.modal", () => this.ui.remove());
    }
    public hideModal() {
        const modalDialog = this.ui.firstElementChild as HTMLElement;
        getModalLauncher().hide(modalDialog);
    }

    public set container(parent: HTMLElement | null) {
        //if we are already attached to a parent then detach ourselves
        if (this.viewContainer && this.ui) {
            this.viewContainer.removeChild(this.ui);
        }
        this.viewContainer = parent;
        if (this.viewContainer) {
            this.viewContainer.appendChild(this.ui);
            // we need to ensure we have the child elements built
            this.render();
        } else {
            this.ui = this.newDiv();
        }
    }
    public get container(): HTMLElement | null {
        return this.viewContainer;
    }
}
